<template>
    <div :class="['acell', cellType]" :style="{ '-webkit-line-clamp': lineClamp }" @click="opened = !opened">
        <div
            v-if="defaultAssignmentChain(selectedShift, assignmentType, assignments).length === 0"
            v-text="$t('assignments.defaultIsEmpty')"
        ></div>
        <template v-else>
            <a
                v-if="defaultAssignmentOnly(selectedShift, assignmentType, assignments)"
                @click="onCellClick(selectedShift, assignmentType, assignments)"
            >
                {{ $t('assignments.viewdef') }}
            </a>

            <template v-else>
                <span
                    v-for="(d, index) in defaultAssignmentChainLastPart(
                        selectedShift,
                        assignmentType,
                        assignments
                    )"
                    :key="index"
                    :title="d"
                    class="icon-phone"
                    v-text="d"
                ></span>
            </template>
        </template>
    </div>
</template>

<script type="text/babel">
export default {
    props: {
        cellType: {
            type: String,
            required: true,
        },

        assignmentType: {
            type: String,
            required: true,
        },

        selectedShift: {
            type: Number,
            required: true,
        },

        assignments: {
            type: Object,
            required: true,
        },

        defaultAssignmentChain: {
            type: Function,
            required: true,
        },

        defaultAssignmentOnly: {
            type: Function,
            required: true,
        },

        onCellClick: {
            type: Function,
            required: true,
        },

        defaultAssignmentChainLastPart: {
            type: Function,
            required: true,
        },

        numberOfLines: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            opened: false,
        };
    },

    computed: {
        lineClamp() {
            return this.opened ? 'unset' : this.numberOfLines;
        },
    },
};
</script>
